export const usersRanking = [
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 2292,
        totalOrdersItemsCount: 10917,
    },
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 2194,
        totalOrdersItemsCount: 10297,
    },
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 543,
        totalOrdersItemsCount: 2397,
    },
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 45,
        totalOrdersItemsCount: 137,
    },
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 44,
        totalOrdersItemsCount: 44,
    },
    {
        fullName: "انبار",
        photo: "https://joeschmoe.io/api/v1/random",
        totalOrdersCount: 4,
        totalOrdersItemsCount: 19,
    },
]
